import { Slider as MuiSlider, SliderProps as MuiSliderProps } from '@mui/material';
import { forwardRef } from 'react';

type Props = Pick<
  MuiSliderProps,
  | 'value'
  | 'onChange'
  | 'onBlur'
  | 'min'
  | 'max'
  | 'step'
  | 'marks'
  | 'disabled'
  | 'name'
  | 'className'
  | 'sx'
> & {
  size?: 'small' | 'medium';
  testId?: string;
};

const Slider = forwardRef<HTMLSpanElement, Props>(
  (
    {
      value,
      onChange,
      onBlur,
      min,
      max,
      step,
      marks,
      disabled,
      name,
      size = 'medium',
      className,
      sx,
      testId,
    },
    ref,
  ) => (
    <MuiSlider
      ref={ref}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      min={min}
      max={max}
      step={step}
      marks={marks}
      disabled={disabled}
      name={name}
      size={size}
      valueLabelDisplay="off"
      className={className}
      test-id={testId}
      sx={sx}
    />
  ),
);

Slider.displayName = 'Slider';
export type { Props as SliderProps };
export default Slider;
